import { Form, Input } from 'antd';
import type { useTransactionAccountField } from '../../utils/transactionAccountField';

interface Props {
  field: ReturnType<typeof useTransactionAccountField>;
  paymentMethod: string | undefined;
}

/**
 * Shown once payment method isn't Cash. Pre-filled with the account/wallet number already on the
 * profile; editing it here corrects that saved number rather than recording a separate one for
 * this transaction, since the system has nowhere else to keep it.
 */
export default function TransactionAccountField({ field, paymentMethod }: Props) {
  if (!paymentMethod || paymentMethod === 'Cash') return null;

  return (
    <Form.Item label="Account / wallet number" help="Saved on the profile. Edit here to correct it.">
      <Input
        value={field.value}
        onChange={(e) => field.onChange(e.target.value)}
        placeholder="Account title, IBAN or wallet number"
      />
    </Form.Item>
  );
}
